export default "__VITE_ASSET__6d39bd33__"